import { render, staticRenderFns } from "./documentation-detail.vue?vue&type=template&id=640926f4"
import script from "./documentation-detail.vue?vue&type=script&lang=js"
export * from "./documentation-detail.vue?vue&type=script&lang=js"
import style0 from "./documentation-detail.vue?vue&type=style&index=0&id=640926f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports